import api from "../Service/Api";
import { toastr } from "react-redux-toastr";

const userBaseController = "api/users";

export const Login = async (body) => {
  if (navigator.onLine === false) {
    toastr.error("No Internet Connection", "Try again");
  } else {
    try {
      const response = await api.post(`${userBaseController}/auth`, body);
      return response.data.data;

    } catch (error) {
      if (error?.response?.data?.message === 'User record not found') {
        toastr.error("User not found", "Please check your credentials and try again");
      } else {
        toastr.error("Ooops, an error occurred", "and it's not your fault, please try again shortly!");
      }
      throw error;
    }
  }
};

export const authCmByGuidApi = async body => {
  if (navigator.onLine === false) {
    toastr.error("No Internet Connection", "Please try again")
  } else {
    try {
      const response = await api.post(`${userBaseController}/authCm`, body)
      toastr.success('Verification Successful!')
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
}

export const getCorpsMember = async (body) => {
  if (navigator.onLine === false) {
    toastr.error("No Internet Connection", "Try again");
  } else {
    try {
      const response = await api.post(`${userBaseController}/get-corp-member`, body);
      // console.log({ response })
      if (typeof response !== "undefined")
        if (response.status === 200) {
          // toastr.success("Get Corps Member", "success");
          return response.data.data;
        } else {
          toastr.error("Get Corps Member", response.data.Msg);
        }
    } catch (ex) {
      toastr.error("Get Corps Member", "An error occurred");
    }
  }
};

export const changePasswordApi = async body => {
  try {
    if (navigator.onLine) {
      const response = await api.patch(`${userBaseController}/change-password`, body)
      toastr.success("Password changed successsfully!")
      return response.data;
    }
  } catch (error) {
    toastr.error('Oops', 'We encountered an error changing your password. Please try again shortly');
    throw error;
  }
}

export const RegisterLGIApi = async body => {
  try {
    if (navigator.onLine) {
      const response = await api.post(`${userBaseController}/register-lgi`, body)
      toastr.success("Registered LGI successsfully!")
      return response.data;
    }
  } catch (error) {
    toastr.error('Oops', 'We encountered an error. Please try again shortly');
    throw error;
  }
}

export const fetchAllLGIUsersApi = async (params) => {

  try {
    if (navigator.onLine) {
      const response = await api.get(`${userBaseController}/get-all-Lgi-users`, {
        params,
      });
      toastr.success("Fetched LGI successsfully!")
      return response.data;
    }
  } catch (error) {
    toastr.error('Oops', 'We encountered an error. Please try again shortly');
    throw error;
  }

};

export const relocateLGIApi = async body => {
  try {
    if (navigator.onLine) {
      const response = await api.post(`${userBaseController}/relocate-lgi`, body)
      toastr.success("Relocated LGI successsfully!")
      return response.data;
    }
  } catch (error) {
    toastr.error('Oops', 'We encountered an error. Please try again shortly');
    throw error;
  }
}


export const engageLGIApi = async (lgiId) => {
  try {
    if (navigator.onLine) {
      const response = await api.post(`${userBaseController}/Engage-LGI-by-Id/${lgiId}`)
      toastr.success("Activated LGI successsfully!")
      return response.data;
    }
  } catch (error) {
    toastr.error('Oops', 'We encountered an error. Please try again shortly');
    throw error;
  }
}
export const disengageLGIApi = async (lgiId) => {
  try {
    if (navigator.onLine) {
      const response = await api.post(`${userBaseController}/Disengage-LGI-by-Id/${lgiId}`)
      toastr.success("Deactivated LGI successsfully!")
      return response.data;
    }
  } catch (error) {
    toastr.error('Oops', 'We encountered an error. Please try again shortly');
    throw error;
  }
}

export const resetPasswordApi = async (userId) => {
  try {
    if (navigator.onLine) {
      const response = await api.post(`${userBaseController}/reset-password/${userId}`)
      toastr.success("Reset Password successsfully!")
      return response.data;
    }
  } catch (error) {
    toastr.error('Oops', 'We encountered an error. Please try again shortly');
    throw error;
  }
}
